import React from 'react';
import { ExternalLink, ExternalLinkProps, FontIcon, IconSetType } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import SvgIcon from '../SvgIcon';
import { UISize } from '../types';

export interface ISocialIconProps {
  href?: string;
  icon: IconSetType;
  size?: UISize;
  className?: string;
  legacy?: boolean;
}

export type ISimplifiedSocialButtonProps = Pick<ISocialIconProps, 'href'> &
  Pick<ISocialIconProps, 'className'> &
  Pick<ExternalLinkProps, 'onClick'>;
const blockName = 'social-icon';

export default function SocialIcon({ legacy, href, icon, className, size = '2xl', ...otherProps }: ISocialIconProps) {
  const bem = bemBlock(blockName);

  // TODO: migrate to use SvgIcon
  // TODO: use packages/@gik/core/assets/img/social/facebook.svg etc. (Make a icon set for social icons)
  const child = legacy ? (
    <FontIcon name={icon.name} {...otherProps} />
  ) : (
    <SvgIcon {...icon} size={size} {...otherProps} />
  );

  return href ? (
    <ExternalLink className={bem(null, null, [className])} href={href}>
      {child}
    </ExternalLink>
  ) : (
    <div className={bem(null, null, [className])}>{child}</div>
  );
}
